import { render, staticRenderFns } from "./OwnerHead.vue?vue&type=template&id=ad3b1d76&scoped=true"
import script from "./OwnerHead.vue?vue&type=script&lang=js"
export * from "./OwnerHead.vue?vue&type=script&lang=js"
import style0 from "./OwnerHead.vue?vue&type=style&index=0&id=ad3b1d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3b1d76",
  null
  
)

export default component.exports